import React, { useState, useRef } from 'react'
import { toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
const Requirment = () => {
    const [rows, setRows] = useState([
        { DocumentName: '', Mandatory: '' },
    ]);
    // let chargeMapping = {
    //     DocumentName: Yup.string().required('Charge Name is required'),
    //     Mandatory: Yup.string().required('Charge Code is required'),
    //     air_Mandatory: Yup.string().required('Air Charge Code is required'),
    // };
    // Function to add a new row
    const addRow = async () => {
        const currentRow = rows[rows.length - 1];

        // Validate current row before adding a new row

        if (currentRow) {
            setRows([...rows, { DocumentName: '', Mandatory: '' }]);
            // formik.setFieldValue('rows', [...rows, { DocumentName: '', Mandatory: '', air_Mandatory: '' }]);
        } else {
            toast.error('Please fill all fields before adding a new row.');
        }
    };

    // Function to remove a row
    const removeRow = (index) => {
        if (rows.length > 1) {
            const updatedRows = rows.filter((_, i) => i !== index);
            setRows(updatedRows);
            // formik.setFieldValue('rows', updatedRows);
        } else {
            alert('At least one row must remain.');
        }
    };

    // Handle input change in each row
    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedRows = [...rows];
        updatedRows[index][name] = value;
        setRows(updatedRows);
        // formik.setFieldValue(`rows[${index}].${name}`, value);
    };

    return (
        <div className='card'>
            <div className="card-body">
                <div className="table-responsive ">
                    {/* <Table className="table datanew dataTable no-footer" pagination={false}
            dataSource={dataSource} columns={columns} /> */}
                    <table className="table table-responsive">
                        <thead>
                            <tr>
                                {/* <th scope="col">#</th> */}
                                <th scope="col" className='bg-none'>Document Name</th>
                                <th scope="col" className='bg-none'>Mandatory</th>
                                {/* <th scope="col" className='bg-none'>Airline Charge Code</th> */}
                                <th scope="col" className='bg-none'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm`}
                                            name="DocumentName"
                                            placeholder="Enter Document Name"
                                            value={row.DocumentName}
                                            onChange={(event) => handleInputChange(index, event)}

                                        />

                                    </td>
                                    <td>
                                        <input type="checkbox"  className="form-check-input" id="exampleCheck1" />

                                    </td>

                                    <td>
                                        <div className="d-flex">
                                            <div className="add-icon cursor-pointer" onClick={addRow}>
                                                <AddIcon />
                                            </div>
                                            {index > 0 && (
                                                <div
                                                    className="remove-icon cursor-pointer"
                                                    onClick={() => removeRow(index)}
                                                    style={{ marginLeft: '10px' }}
                                                >
                                                    <DeleteIcon />
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    )
}

export default Requirment